import { useCallback } from 'react';
import { trackEvent, trackPageView, trackUserAction, trackError, trackConversion, identifyUser, clearUserIdentification } from '../utils/amplitude';

export const useAmplitude = () => {
  const track = useCallback((eventName: string, eventProperties?: Record<string, any>) => {
    trackEvent(eventName, eventProperties);
  }, []);

  const trackPage = useCallback((pageName: string, pageProperties?: Record<string, any>) => {
    trackPageView(pageName, pageProperties);
  }, []);

  const trackAction = useCallback((action: string, properties?: Record<string, any>) => {
    trackUserAction(action, properties);
  }, []);

  const trackErrorEvent = useCallback((error: string, errorDetails?: Record<string, any>) => {
    trackError(error, errorDetails);
  }, []);

  const trackConversionEvent = useCallback((conversionType: string, value?: number, properties?: Record<string, any>) => {
    trackConversion(conversionType, value, properties);
  }, []);

  const identifyUserInAmplitude = useCallback((userId: string, userProperties: {
    firstName?: string;
    lastName?: string;
    email?: string;
    role?: string;
  }) => {
    identifyUser(userId, userProperties);
  }, []);

  const clearUserFromAmplitude = useCallback(() => {
    clearUserIdentification();
  }, []);

  return {
    track,
    trackPage,
    trackAction,
    trackError: trackErrorEvent,
    trackConversion: trackConversionEvent,
    identifyUser: identifyUserInAmplitude,
    clearUser: clearUserFromAmplitude,
  };
}; 